import { render } from "./SecurityPolicy.vue?vue&type=template&id=e96025c6&scoped=true"
import script from "./SecurityPolicy.vue?vue&type=script&lang=js"
export * from "./SecurityPolicy.vue?vue&type=script&lang=js"

import "./SecurityPolicy.vue?vue&type=style&index=0&id=e96025c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96025c6"]])

export default __exports__